<template>
  <div class="box2">
    <div class="tableBox">
      <div class="boxTitle">作业中</div>
      <el-table
        :data="tableDataWork"
        border
        style="width: 98%;margin: auto">
        <el-table-column
          prop="no"
          label="编号">
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称">
        </el-table-column>
        <el-table-column
          prop="locationName"
          label="区域">
        </el-table-column>
        <el-table-column
          label="优先级">
          <template slot-scope="scope">
            {{ workLevel[scope.row.riskGrade] }}
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="regionPage">
        <el-pagination
          background @current-change="handleChange1"
          layout="prev, pager, next" size="mini"
          :total="total1" :current-page="curPage1" :page-size="limit1">
        </el-pagination>
      </div>
    </div>

    <div class="tableBox">
      <div class="boxTitle">风险点复评</div>
      <el-table
        :data="tableDataRiskPoint"
        border
        style="width: 98%;margin: auto">
        <el-table-column
          prop="riskName"
          label="风险点名称">
        </el-table-column>
        <el-table-column
          label="类型">
          <template slot-scope="scope">
            {{ riskPointType[scope.row.riskType] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="dangerAreaName"
          label="区域">
        </el-table-column>
        <el-table-column
          label="评价结果">
          <template slot-scope="scope">
            {{ riskPointResult[scope.row.result] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="address"
          label="管控级别">
          <template slot-scope="scope">
            {{ riskPointLevel[scope.row.controlLevel] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="nextEvaluationTime"
          label="下次评价时间">
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="regionPage">
        <el-pagination
          background @current-change="handleChange2"
          layout="prev, pager, next" size='small'
          :total="total2" :current-page="curPage2" :page-size="limit2">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getAreaWorkList, getAreaRiskPointList } from "@/api/earlyWarning"
export default {
  name: 'region',
   data() {
    return {
      // 作业中的数据
      tableDataWork: [],
      total1: 0,
      curPage1: 1,
      limit1: 10,
      workLevel: ["低","中","高"],
      // 风险点的数据
      tableDataRiskPoint: [],
      total2: 0,
      limit2: 10,
      curPage2: 1,
      riskPointType: ["固有风险","作业风险","设备风险"],
      riskPointResult: ["重大风险","较大风险","一般风险","低风险"],
      riskPointLevel: ["重大风险","较大风险","一般风险","低风险"]
    }
  },
  methods: {
    getWorkList() {
      getAreaWorkList({ limit: this.limit1, curPage: this.curPage1 }).then(res => {
        this.tableDataWork = res.body.data
        this.total1 = res.body.cum
      })
    },
    handleChange1(val) {
      this.curPage1 = val
      this.getWorkList()
    },

    getRiskPointList() {
      getAreaRiskPointList({ limit: this.limit2, curPage: this.curPage2 }).then(res => {
        this.tableDataRiskPoint = res.body.data
        this.total2 = res.body.cum
      })
    },
    handleChange2(val) {
      this.curPage2 = val
      this.getRiskPointList()
    } 
  },
  created() {
    this.getWorkList()
    this.getRiskPointList()
  }
}
</script>

<style scoped>
  .box2 {
    display: flex;
    justify-content: space-between
  }
  .tableBox {
    width: 49.5%;
    border: 1px solid rgb(232,232,232);
  }
  .boxTitle{
    font-size: 16px;
    line-height: 25px;
    padding-left: 10px;
    margin: 5px 0;
  }
  .regionPage {
    text-align: right;
    margin-top: 10px;
    margin-bottom: 7px
  }
</style>